import React from "react";
import {
  Box,
  ImageBox,
  HeroBlurb,
  Section,
  Page,
  Heading,
  Elevation,
  PageContentWrapWithSideBar,
  Link,
  Text,
  Blurb
} from "../theme";
import Pic from "../assets/eg1.jpg";
import { Practices as practicesData } from "../data";
import { map, startCase } from "lodash";
const Practices = props => {
  return (
    <Page flexWrap="wrap">
      <ImageBox useFilter="true" width={1} bgImage={Pic}>
        <HeroBlurb heading="Practices" image={Pic} color="secondaryLight" />
      </ImageBox>
      <PageContentWrapWithSideBar
        aboutTitle="About Our Practices"
        aboutText="Egerton, McAfee offers an extensive range of legal services to
            national, regional and local clients. Experienced lawyers can be
            drawn from any of our practice groups to provide on-point solutions
            to the many facets of complex transactions and disputes. The
            firm’s strong business practice has breadth and depth that enables
            it to meet virtually all its corporate and individual clients’
            legal needs. In addition, the firm’s litigation group represent
            clients in matters before state and federal courts in Tennessee and
            elsewhere and in arbitration, mediation and alternative dispute
            resolution proceedings. Below you will find a full listing of our
            practice areas—click on an area of interest to learn more about
            that specific area."
      >
        <Section bg="secondaryLight" px={6} pt={5}>
          <Box alignContent="center" width={[1, null, null, 1 / 2]}>
            <Heading width={1} textAlign="center" fontSize={4}>
              Business Law
            </Heading>
            <Box
              display="flex"
              width={[1]}
              justifySelf="center"
              flexWrap="wrap"
              justifyContent="space-around"
            >
              {map(practicesData, (practice, key) => (
                <Elevation
                  tag={Link}
                  display="flex"
                  bg="#244f7a"
                  justifyContent="center"
                  alignItems="center"
                  width={[1, "40%"]}
                  boxShadow="large"
                  color="white"
                  my={2}
                  height={120}
                  to={`/practices/taxation`}
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    textDecoration: "none"
                  }}
                >
                  <Text lineHeight={1} mb={0}>
                    {startCase(key)}
                  </Text>
                </Elevation>
              ))}
            </Box>
          </Box>
          <Box alignContent="center" width={[1, null, null, 1 / 2]}>
            <Heading width={1} textAlign="center" fontSize={4}>
              Litigation
            </Heading>
            <Box
              display="flex"
              width={[1]}
              justifySelf="center"
              flexWrap="wrap"
              justifyContent="space-around"
            >
              {map(practicesData, (practice, key) => (
                <Elevation
                  tag={Link}
                  display="flex"
                  bg="#244f7a"
                  justifyContent="center"
                  alignItems="center"
                  width={[1, "40%"]}
                  mx={2}
                  boxShadow="large"
                  color="white"
                  my={2}
                  height={120}
                  to={`/practices/taxation`}
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    textDecoration: "none"
                  }}
                >
                  <Text lineHeight={1} mb={0}>
                    {startCase(key)}
                  </Text>
                </Elevation>
              ))}
            </Box>
          </Box>
        </Section>
      </PageContentWrapWithSideBar>
    </Page>
  );
};
export default Practices;
